import { useApp } from "@next-platform/client-common-core";
import { Spinner } from "@nextui-org/react";

import PageMetaTags from "@/components/common/PageMetaTags";
import { Text } from "@/components/customComponents";
import SearchClientCharacterListing from "@/components/search/SearchClientCharacterListing";
import Trans from "@/components/Trans/Trans";
import { FEATURE_FLAGS } from "@/constants";
import { useFeatureFlag } from "@/hooks";
import { NotFound } from "@/pages";
import AnonymousMarketing from "@/pages/AnonymousMarketing/AnonymousMarketing";
import useAuth from "@/services/useAuth";
import { Collection } from "@/types/api";

const LorebooksExplore = () => {
  const { hasFeatureFlag: hasLorebookDiscoverPublic } = useFeatureFlag(FEATURE_FLAGS.LOREBOOK_DISCOVER_PUBLIC);
  const { applicationName } = useApp();
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();

  // Wait for auth to settle so we don't briefly flash the anonymous landing to
  // a signed-in user (or vice versa).
  if (isAuthLoading) {
    return <Spinner className="flex h-[50vh] items-center justify-center" />;
  }

  // Anonymous visitors always get the public marketing landing, independent of
  // the discovery feature flag (which gates the logged-in listing experience).
  if (!isAuthenticated) {
    return (
      <>
        <PageMetaTags canonicalUrl={`https://docs.${applicationName}.ai/product-guides/lorebook`} />
        <AnonymousMarketing datakey="lorebookDiscover" />
      </>
    );
  }

  if (!hasLorebookDiscoverPublic) {
    return <NotFound />;
  }

  return (
    <>
      <PageMetaTags canonicalUrl={`https://docs.${applicationName}.ai/product-guides/lorebook`} />
      <Text h1 className="m-0 px-4 max-mob:px-2" variant="xxl">
        <Trans i18nKey="appMenu:chatbots.lorebooks" />
      </Text>
      <SearchClientCharacterListing collection={Collection.LOREBOOKS} defaultSortField={"createdAt:desc"} useStoreTagFilters={false} />
    </>
  );
};

export default LorebooksExplore;
